module.exports = __webpack_public_path__ + "img/doc_0.5ded99f5.png";